import React from 'react'

import Modal from 'react-bootstrap/Modal'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

export default function UnsavedChangesModal({
  show,
  isSaving,
  onSave,
  onContinueWithoutSaving,
  onClose,
}) {
  return (
    <Modal
      centered
      animation={false}
      fullscreen="md-down"
      show={show}
      onHide={onClose}
      backdrop="static"
    >
      <Modal.Body>
        <div className="modal-body-heading">
          <h1 className="modal-body-heading-title">Unsaved changes</h1>
          <p className="mb-0">
            You have unsaved changes on this seat map. Save before leaving, or
            continue without saving and your changes will be lost.
          </p>
        </div>
        <Stack className="btn-group-flex">
          <Button size="lg" onClick={onSave} disabled={isSaving}>
            {isSaving ? 'Saving…' : 'Save'}
          </Button>
          <Button
            size="lg"
            variant="outline-light"
            onClick={onContinueWithoutSaving}
            disabled={isSaving}
          >
            Continue without saving
          </Button>
          <Button
            size="lg"
            variant="outline-light"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  )
}
